import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import {truBlueStatus} from 'helpers/constants';
import {injectIntl, FormattedMessage} from 'react-intl';

class TrublueBanner extends React.Component {

  static propTypes = {
    customer: PropTypes.object.isRequired,
    contactName: PropTypes.string.isRequired,
    manageTruBlueState: PropTypes.func.isRequired,
    config: PropTypes.object.isRequired,
    intl: PropTypes.any,
  };

  getTruBlueContent() {
    let {customer, contactName} = this.props;
    let {formatMessage} = this.props.intl;

    if (customer.truBlueStatus === truBlueStatus.Active) {
      return <p>
        <FormattedMessage id='trublue.banner.active.message'
                          values={{
                            customer: contactName || formatMessage({id: 'general.customer'}),
                          }}/>
      </p>;
    }

    if (customer.truBlueStatus && customer.truBlueStatus !== truBlueStatus.Ineligible) {
      return <p>
        <FormattedMessage id='trublue.banner.inactive.message'
                          values={{
                            customer: contactName || formatMessage({id: 'general.customer'}),
                          }}/>
      </p>;
    }

    return null;
  }


  render() {
    let {customer, manageTruBlueState, config, intl} = this.props;
    let isCustomerActive = customer.truBlueStatus && customer.truBlueStatus === truBlueStatus.Active;

    if (!config) {
      return null;
    }

    //Display only TB Banners during claimable dates
    if(moment().isAfter(config.claimEnd) || moment().isBefore(config.claimStart)) {
      return null;
    }

    let isTBRegistrationClosed = moment().isAfter(config.regEndDate) ||
      moment().isBefore(config.regStartDate);

    if (!isCustomerActive && isTBRegistrationClosed ||
      !customer.truBlueStatus ||
      customer.truBlueStatus === truBlueStatus.Ineligible) {
      return null;
    }

    const {formatMessage, locale} = this.props.intl;

    return <div className={classNames('trublue-banner', {
      'trublue-banner--active': isCustomerActive,
      'trublue-banner--inactive': !isCustomerActive,
    }, 'pointer')}
                onClick={manageTruBlueState(isTBRegistrationClosed)}>
      <span className="trublue-banner__item">
        <i className={classNames('bl', 'icon', 'bl-tru-blue-icon bl-tru-blue-filled', 'bl-tru-blue-circle-icon', {
          'blue': isCustomerActive,
          'grey': !isCustomerActive,
        })}/>
      </span>
      <span className="trublue-banner__item">
        <img src={locale === 'fr-CA' ? '/Content/img/trublue/trublue-promise-logo-fr.png' : '/Content/img/trublue/trublue-promise-logo.png'}
               alt={formatMessage({id: 'trublue.promise'})}
               className='trublue-banner__logo'/>
      </span>
      <span className="trublue-banner__item trublue-banner__keyline"/>
      <div className="trublue-banner__item trublue-banner__content">
        {this.getTruBlueContent()}
      </div>
    </div>;
  }


}

export default injectIntl(TrublueBanner);
